import { createContext, useContext, useEffect } from 'react';

export interface AdsConfigOverride {
  brandGroupId: string;
  utmSource: string;
}

export interface IAdsConfigOverrideContext {
  setOverride: (override: AdsConfigOverride | null) => void;
}

export const AdsConfigOverrideContext = createContext<IAdsConfigOverrideContext | undefined>(undefined);

/**
 * Lets a page tell the single root AdsLayout which brand group / utm source its ads should use.
 * Pass `null` while the values are not known yet. The override is cleared on unmount.
 */
export const useAdsConfigOverride = (override: AdsConfigOverride | null): void => {
  const ctx = useContext(AdsConfigOverrideContext);
  const setOverride = ctx?.setOverride;
  const brandGroupId = override?.brandGroupId;
  const utmSource = override?.utmSource;

  useEffect(() => {
    if (!setOverride) {
      return undefined;
    }
    setOverride(brandGroupId === undefined ? null : { brandGroupId, utmSource: utmSource ?? '' });
    return () => setOverride(null);
  }, [setOverride, brandGroupId, utmSource]);
};
